import { takeLatest, put, call, all } from "redux-saga/effects";
import authService from "../../services/authService";
import LoginService from "../../services/loginService";
import * as appConstants from './../constants/appConstants';
import * as authConstants from './../constants/authConstants';
import { getLocalStorage, removeLocalStorage } from "../../helpers/storage";

function* loginSaga(action) {
  try {
    const { history } = action;
    const data = yield call(authService.login);
    //console.log("Data:", data)
    //const data = yield call(LoginService.sendLoginData, data.token, data.);
    yield put({ type: authConstants.LOGIN_SUCCESS, message: data.message, data, history });
  } catch (error) {
    yield put({ type: authConstants.LOGIN_FAILURE, message: error.message });
  }
}

function* logoutSaga(action) {
  try {
    const { history } = action;
    const data = yield call(authService.logout);
    yield put({ type: authConstants.LOGOUT_SUCCESS, message: "Logout exitoso", data, history });
  } catch (error) {
    yield put({ type: authConstants.LOGOUT_FAILURE, message: error.message });
  }
}

function* authenticateUserSaga(action) {
  const { history } = action;
  try {
    const storedToken = getLocalStorage("token");
    const storedRefreshToken = getLocalStorage("refreshToken");
    const data = yield call(authService.verifyToken, storedToken, storedRefreshToken);
    const data2 = yield call(LoginService.sendLoginData, data.token, data.email);
    yield put({ type: authConstants.AUTHENTICATE_USER_SUCCESS, data });
  } catch (error) {
    yield put({
      type: authConstants.AUTHENTICATE_USER_FAILURE,
      payload: error.message,
      history
    });
  }
} 

export function* watchAuth() {
  yield all([
    takeLatest(appConstants.APP_INITIALIZE_REQUESTED, authenticateUserSaga),
    takeLatest(authConstants.AUTHENTICATE_USER_REQUESTED, authenticateUserSaga),
    takeLatest(authConstants.LOGIN_REQUEST, loginSaga),
    takeLatest(authConstants.LOGOUT_REQUEST, logoutSaga),
  ]);
}